import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconDelete = (props) => (
  <SvgIcon {...props}>
    <g>
      <path d="M9.5,2.1c1.7,0,3.3,0,5,0c0,0,0,0,0.1,0C15.5,2.4,16.1,3,16.3,4c0,0.2,0,0.4,0,0.6c0.1,0,0.1,0,0.2,0
		c1.1,0,2.3,0,3.4,0c0.4,0,0.6,0.3,0.6,0.6c0,0.4-0.3,0.6-0.6,0.6c-0.3,0-0.7,0-1,0c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.1,0,0.2
		c0,2.6,0,5.2,0,7.9c0,1.9,0,3.9,0,5.8c0,1-0.6,1.8-1.5,2.1c-0.1,0-0.2,0.1-0.3,0.1c-3.3,0-6.6,0-9.9,0c0,0,0,0,0,0
		c-1.2-0.3-1.8-1.1-1.8-2.3c0-4.5,0-9,0-13.5c0-0.1,0-0.1,0-0.2c-0.4,0-0.8,0-1.2,0c-0.3,0-0.5-0.2-0.6-0.4C3.3,5,3.6,4.6,4,4.6
		c1.1,0,2.3,0,3.4,0c0.1,0,0.1,0,0.2,0c0-0.2,0-0.3,0-0.4c0-0.7,0.3-1.3,0.9-1.7C8.9,2.4,9.2,2.3,9.5,2.1z M6.5,5.8
		c0,0.2,0,0.4,0,0.5c0,4.4,0,8.9,0,13.3c0,0.6,0.4,1,1,1c3,0,6.1,0,9.1,0c0.6,0,1-0.4,1-1c0-4.5,0-9.1,0-13.6c0-0.1,0-0.1,0-0.2
		C13.8,5.8,10.2,5.8,6.5,5.8z M15.1,4.6c0-0.1,0-0.2,0-0.2c0-0.6-0.4-1-1-1c-1.4,0-2.8,0-4.2,0C9.3,3.4,8.8,3.9,9,4.6
		C11,4.6,13,4.6,15.1,4.6z"/>
      <path d="M9.5,13.3c0,1.6,0,3.2,0,4.9c0,0.5-0.4,0.8-0.8,0.6c-0.3-0.1-0.4-0.3-0.4-0.6c0-1.2,0-2.3,0-3.5
		c0-2.1,0-4.2,0-6.2c0-0.5,0.5-0.8,0.9-0.6c0.2,0.1,0.3,0.3,0.3,0.6c0,1.5,0,3,0,4.5C9.5,13,9.5,13.1,9.5,13.3z"/>
      <path d="M12.6,13.3c0,1.6,0,3.2,0,4.9c0,0.5-0.4,0.8-0.8,0.6c-0.3-0.1-0.4-0.3-0.4-0.6c0-0.9,0-1.9,0-2.8
		c0-2.3,0-4.6,0-6.9c0-0.5,0.4-0.8,0.9-0.6c0.3,0.1,0.4,0.3,0.4,0.6c0,1.5,0,3,0,4.5C12.6,13,12.6,13.1,12.6,13.3z"/>
      <path d="M15.7,13.2c0,1.6,0,3.3,0,4.9c0,0.5-0.4,0.8-0.8,0.6c-0.3-0.1-0.4-0.3-0.4-0.6c0-0.9,0-1.9,0-2.8
		c0-2.3,0-4.6,0-6.9c0-0.5,0.4-0.8,0.8-0.6c0.3,0.1,0.4,0.3,0.4,0.6c0,1.5,0,3,0,4.5C15.7,13,15.7,13.1,15.7,13.2z"/>
    </g>
  </SvgIcon>
);
// IconDelete = pure(IconDelete);
IconDelete.displayName = 'IconDelete';
IconDelete.muiName = 'SvgIcon';

export default IconDelete;



// WEBPACK FOOTER //
// ./src/components/Icons/IconDelete.js